import BulletPointsCard from '../BulletPointsCard'
import Direct from '../../Icons/coaching/direct.svg'
import Review from '../../Icons/coaching/review.svg'
import Professional from '../../Icons/coaching/professional.svg'
import CallAction from './CallAction'
import Footer from '../Footer'

const bulletPoints = [
    {
        title: 'Direct Access to Experts',
        description:
            'Enjoy direct access to your coach for personalized support and advice, regardless of office hours.',
        icon: Direct,
    },
    {
        title: 'Campaign Performance Review',
        description:
            'Regularly review your campaign results and receive guidance on next steps to continually improve your strategy.',
        icon: Review,
    },
    {
        title: 'Professional Assistance',
        description:
            'Get expert help to achieve your personal and professional goals, ensuring your direct mail campaigns are as successful as possible.',
        icon: Professional,
    },
]

function Support({ shouldAddFooter = true, ...props }) {
    return (
        <div className="bg-light-yellow-gradient rounded-10xl md:rounded-8xl space-y-16">
            <BulletPointsCard
                {...props}
                title="Ongoing Support and Guidance"
                bulletPoints={bulletPoints}
                imagePath="/assets/coaching/5.png"
                imageAlt="A close-up of two people in business suits shaking hands against a bright, sunlit background with a reflection of city buildings."
                imageTitle="Business handshake and agreement."
                mobileImagePath={'/assets/coaching/5-mobile.png'}
                alignment={'left'}
                bg="true"
            />
            {shouldAddFooter && (
                <>
                    <CallAction />
                    <Footer />
                </>
            )}
        </div>
    )
}

export default Support
